import styled from '@emotion/styled'
import React from 'react'

import { useWhitelabel } from 'main/framework'
import { ExternalSchool_externalSchool } from 'main/gql/externalSchool'
import { spacing } from 'main/ui'

import { AssetName } from 'main/util/asset'
import ProgramType from '../LicenseInformation/ProgramType'
import AcceptedSubsidies from './AcceptedSubsidies'
import Ages from './Ages'
import DaysOfWeek from './DaysOfWeek'
import EnabledProgramOfferings from './EnabledProgramOfferings'
import Hours from './Hours'
import NetworkRating from './NetworkRating'
import NetworkRatingV2 from './NetworkRatingV2'
import Philosophy from './Philosophy'
import Provider from './Provider'
import SpokenLanguages from './SpokenLanguages'
import Subsidized from './Subsidized'

const ExternalBasicsContainer = styled.div`
  display: flex;

  > * {
    flex: 1;
  }
`

const Column = styled.div`
  > * {
    margin: ${spacing.majorScale(2)}px 0;
  }
`

export function ExternalBasics(props: { school: ExternalSchool_externalSchool }) {
  const { school } = props
  const { profile, programType } = school

  const whitelabel = useWhitelabel()

  if (!profile) return null

  const {
    philosophy,
    philosophySecondary,
    ageMonthsMax,
    ageMonthsMin,
    daysOfWeek,
    hoursEnd,
    hoursStart,
    spokenLanguages,
    subsidizedCareAccepted,
    networkRating,
    whitelabelRating,
    subsidies,
    programOfferings,
  } = profile

  return (
    <ExternalBasicsContainer>
      <Column>
        {philosophy && philosophy !== 'hidden' && (
          <Philosophy philosophy={philosophy} philosophySecondary={philosophySecondary} />
        )}
        {ageMonthsMax && <Ages ageMonthsMax={ageMonthsMax} ageMonthsMin={ageMonthsMin || 0} />}
        {hoursEnd && hoursStart && <Hours hoursEnd={hoursEnd} hoursStart={hoursStart} />}
        {daysOfWeek.some(day => day) && <DaysOfWeek daysOfWeek={daysOfWeek} />}
        {subsidizedCareAccepted && <Subsidized subsidizedCareAccepted={subsidizedCareAccepted} />}
        {whitelabel.hideByDefaultExceptIfTrue(AssetName.NETWORK_RATING_DISPLAY__DETAIL__BASICS) && (
          <NetworkRating networkRating={networkRating} />
        )}
        {whitelabelRating &&
          whitelabel.hideByDefaultExceptIfTrue(AssetName.NETWORK_RATING_FILTERS_V2) && (
            <NetworkRatingV2 whitelabelRating={whitelabelRating} />
          )}
        {whitelabel.hideByDefaultExceptIfTrue(AssetName.SUBSIDY_BUDGET_FILTER) && (
          <AcceptedSubsidies subsidies={subsidies} />
        )}
        <EnabledProgramOfferings programOfferings={programOfferings} />
      </Column>
      <Column>
        {programType && <ProgramType programType={programType} />}
        <Provider externalSchool={school} />
        <SpokenLanguages spokenLanguages={spokenLanguages} />
      </Column>
    </ExternalBasicsContainer>
  )
}
